import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Hamburger.css';

class Hamburger extends Component {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const { handleClick } = this.props;
    handleClick();
  }

  render() {
    let { opened } = this.props;
    let hamburgerClass = classnames(styles.hamburger, { [styles.open]: opened });

    return (
      <div className={hamburgerClass} onClick={this.handleClick}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/hamburger/Hamburger.js